import { Container, styled } from "@mui/material";

import theme from "~frontend/theme";

export default styled(Container)({
  paddingTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
});
